import { ArrowLeft } from 'lucide-react'
import * as React from 'react'
import modelmaticBannerLogoText from '@/assets/images/modelmatic_banner_logo_text.png'
import modelmaticLogo from '@/assets/images/modelmatic_logo.png'
import {
	LanguageSwitcher,
	WorkspacePresenceIndicator,
	WorkspaceSwitcher,
} from '@/components/common'
import { useTranslation } from '@/hooks/useTranslation'

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	isLogoCentered?: boolean
	currentPage?: string
	headerTitle?: string
	onBack?: () => void
}

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(
	({ isLogoCentered, headerTitle, onBack, ...props }, ref) => {
		const { t } = useTranslation()

		return (
			<header
				ref={ref}
				className={`flex items-center justify-between w-full h-12 bg-card text-card-foreground ring-foreground/10 ring-1 sticky top-0 z-20 ${isLogoCentered ? 'px-5' : 'px-10 md:px-20'}`}
				{...props}
			>
				{isLogoCentered && (
					<button
						type="button"
						aria-label={t('header.back')}
						className="cursor-pointer active:scale-[85%] hover:scale-[115%] transition-all duration-300 ease-in-out"
						onClick={() => {
							if (onBack) {
								onBack()
							} else {
								window.history.back()
							}
						}}
					>
						<ArrowLeft />
					</button>
				)}

				<img
					src={modelmaticBannerLogoText}
					alt={t('header.bannerAlt')}
					className={`${isLogoCentered && 'absolute left-1/2 -translate-x-1/2'} h-full w-auto hidden md:block`}
				/>

				{!isLogoCentered && (
					<img
						src={modelmaticLogo}
						alt={t('header.logoAlt')}
						className="h-full w-auto block md:hidden"
					/>
				)}

				<h1 className="absolute left-1/2 -translate-x-1/2 block md:hidden text-2xl text-gray-900 font-semibold max-w-[50%] truncate ">
					{headerTitle}
				</h1>

				{isLogoCentered ? (
					<div className="flex items-center gap-3">
						<WorkspacePresenceIndicator />
						<WorkspaceSwitcher />
					</div>
				) : (
					<LanguageSwitcher />
				)}
			</header>
		)
	}
)
Header.displayName = 'Header'

export { Header }
